import React from "react";

type UnitHeaderProps = {
  title: React.ReactNode;
};

/**
 * Object title row for the property panel. Unit switching lives in the
 * panel header (mm | in segmented toggle); this row is title-only.
 */
const UnitHeader: React.FC<UnitHeaderProps> = ({ title }) => (
  <div className="flex w-full min-w-0 items-start justify-between gap-2">
    <div
      className="min-w-0 flex-1 break-words text-[13px] font-medium leading-5 text-gray-900"
      title={typeof title === "string" ? title : undefined}
    >
      {title}
    </div>
  </div>
);

export default UnitHeader;
